import Vue from 'vue'
import VueRouter from "vue-router";


import Login from "@/components/Login";
import Products from "@/components/Products/Products";
import ProductCreate from "@/components/Products/ProductCreate";
import ProductUpdate from "@/components/Products/ProductUpdate";
import Collections from "@/components/Collections/Collections";
import CollectionUpdate from "@/components/Collections/CollectionUpdate";
import Default from "@/components/Default";
import CatalogSections from "@/components/CatalogSections/CatalogSectionV";
import Banners from "@/components/Banners/Banners";
import BannerCreate from "@/components/Banners/BannerCreate";
import BannerUpdate from "@/components/Banners/BannerUpdate";
import Advantages from "@/components/Advantages/Advantages";
import AdvantageCreate from "@/components/Advantages/AdvantageCreate";
import AdvantageUpdate from "@/components/Advantages/AdvantageUpdate";
import MainSlides from "@/components/MainSlides/MainSlides";
import MainSlideCreate from "@/components/MainSlides/MainSlideCreate";
import MainSlideUpdate from "@/components/MainSlides/MainSlideUpdate";
import SectionUpdate from "@/components/CatalogSections/SectionUpdate";
import PromoActions from "@/components/PromoActions/PromoActions";
import PromoActionCreate from "@/components/PromoActions/PromoActionCreate";
import PromoActionUpdate from "@/components/PromoActions/PromoActionUpdate";
import Users from "@/components/Users/Users";
import User from "@/components/Users/User";
import Articles from "@/components/Articles/Articles";
import ArticleCreate from "@/components/Articles/ArticleCreate";
import ArticleUpdate from "@/components/Articles/ArticleUpdat";
import FaqSections from "@/components/Faq/FaqSections";
import Faqs from "@/components/Faq/Faqs";
import FaqSectionCreate from "@/components/Faq/FaqSectionCreate";
import FaqSectionUpdate from "@/components/Faq/FaqSectionUpdate";
import ArticleSections from "@/components/ArticleSection/ArticleSections";
import ArticleSectionCreate from "@/components/ArticleSection/ArticleSectionCreate";
import ArticleSectionUpdate from "@/components/ArticleSection/ArticleSectionUpdate";
import Config from "@/components/Config/Config.vue";

// import Presets from "@/components/Presets/Presets";
// import PresetCreate from "@/components/Presets/PresetCreate";
// import PresetUpdate from "@/components/Presets/PresetUpdate";
import PopularCreate from '@/components/Popular/PopularCreate';
import Popular from '@/components/Popular/Popular';
import PopularUpdate from '@/components/Popular/PopularUpdate';
import Comments from "../components/Comments";
import Reviews from "../components/Reviews";
import Home from "../components/Home";
import Storages from "@/components/Storages/Storages";
import StorageCreate from "@/components/Storages/StorageCreate";
import StorageUpdate from "@/components/Storages/StorageUpdate";
import RequestCalls from "@/components/RequestCalls";
import Selections from "@/components/Selections/Selections";
import SelectionCreate from "@/components/Selections/SelectionCreate";
import SelectionUpdate from "@/components/Selections/SelectionUpdate";
import Orders from "@/components/Orders/Orders";
import ChangeOrder from "@/components/Orders/ChangeOrder";
import DiscountCards from "@/components/LoyaltySystem/DiscountCards";
import ApplicationForms from "@/components/LoyaltySystem/ApplicationForms";
import TextPage from "@/components/TextPage/TextPage";
import TextPageCreate from "@/components/TextPage/TextPageCreate";
import TextPageUpdate from "@/components/TextPage/TextPageUpdate";
import Regions from '@/components/Regions/Index';
import RegionsCreate from '@/components/Regions/Create';
import RegionsEdit from '@/components/Regions/Edit';
import TransportCompanies from '@/components/TransportCompanies/Index';
import TransportCompaniesCreate from '@/components/TransportCompanies/Create';
import TransportCompaniesEdit from '@/components/TransportCompanies/Edit';
import Mailing from '@/components/Mailing';

Vue.use(VueRouter);

const routes = [
    { path: '/login', component: Login },
    {
        path: '/', component: Default, children: [
            {
                path: '/',
                component: Home
            },
            {
                path: '/products',
                component: Products
            },
            {
                path: '/product/create',
                component: ProductCreate
            },
            {
                path: '/product/:id/update',
                component: ProductUpdate,
            },
            {
                path: '/collections',
                component: Collections
            },
            {
                path: '/collections/:id/update',
                component: CollectionUpdate,
            },
            {
                path: '/selections',
                component: Selections
            },
            {
                path: '/selection/create',
                component: SelectionCreate
            },
            {
                path: '/selection/:id/update',
                component: SelectionUpdate,
            },
            {
                path: '/catalog-sections',
                component: CatalogSections
            },
            {
                path: '/catalog-section/:id/update',
                component: SectionUpdate
            },
            {
                path: 'banners',
                component: Banners
            },
            {
                path: '/banner/create',
                component: BannerCreate
            },
            {
                path: '/banner/:id/update',
                component: BannerUpdate
            },
            {
                path: 'advantages',
                component: Advantages
            },
            {
                path: '/advantage/create',
                component: AdvantageCreate
            },
            {
                path: '/advantage/:id/update',
                component: AdvantageUpdate
            },
            {
                path: 'main-slides',
                component: MainSlides
            },
            {
                path: '/main-slide/create',
                component: MainSlideCreate
            },
            {
                path: '/main-slide/:id/update',
                component: MainSlideUpdate
            },
            {
                path: 'promo-actions',
                component: PromoActions
            },
            {
                path: '/promo-action/create',
                component: PromoActionCreate
            },
            {
                path: '/promo-action/:id/update',
                component: PromoActionUpdate
            },
            {
                path: '/users',
                component: Users
            },
            {
                path: '/user/:id',
                component: User
            },
            {
                path: '/articles',
                component: Articles
            },
            {
                path: '/article/create',
                component: ArticleCreate
            },
            {
                path: '/article/:id/update',
                component: ArticleUpdate
            },
            // {
            //     path: '/blog/section',
            //     component: ArticleSections,
            // },
            {
                path: '/faq-sections',
                component: FaqSections
            },
            {
                path: '/faq-section/create',
                component: FaqSectionCreate
            },
            {
                path: '/faq-section/:id/update',
                component: FaqSectionUpdate
            },
            {
                path: '/faqs',
                component: Faqs
            },
            {
                path: '/storages',
                component: Storages
            },
            {
                path: '/storage/create',
                component: StorageCreate
            },
            {
                path: '/storage/:id/update',
                component: StorageUpdate
            },
            {
                path: '/regions',
                component: Regions,
            },
            {
                path: '/regions/create',
                component: RegionsCreate,
            },
            {
                path: '/regions/:id/edit',
                component: RegionsEdit,
            },
            {
                path: '/transport-companies',
                component: TransportCompanies,
            },
            {
                path: '/transport-companies/create',
                component: TransportCompaniesCreate,
            },
            {
                path: '/transport-companies/:id/edit',
                component: TransportCompaniesEdit,
            },
            {
                path: '/article-sections',
                component: ArticleSections
            },
            {
                path: '/article-section/create',
                component: ArticleSectionCreate
            },
            {
                path: '/article-section/:id/update',
                component: ArticleSectionUpdate
            },
            // {
            //     path: '/presets',
            //     component: Presets
            // },
            // {
            //     path: '/preset/create',
            //     component: PresetCreate
            // },
            // {
            //     path: '/preset/:id/update',
            //     component: PresetUpdate
            // },
            {
                path: '/popular',
                component: Popular,
            },
            {
                path: '/popular/:id/update',
                component: PopularUpdate
            },
            {
                path: '/popular/create',
                component: PopularCreate,
            },
            {
                path: '/comments',
                component: Comments
            },
            {
                path: '/reviews',
                component: Reviews
            },
            {
                path: '/request-calls',
                component: RequestCalls
            },
            {
                path: '/orders',
                component: Orders
            },
            {
                path: '/order/:id',
                component: ChangeOrder
            },
            {
                path: '/discount-cards',
                component: DiscountCards
            },
            {
                path: '/application-forms',
                component: ApplicationForms
            },
            {
                path: '/text-pages',
                component: TextPage
            },
            {
                path: '/text-pages/create',
                component: TextPageCreate,
            },
            {
                path: '/mailing',
                component: Mailing,
            },
            {
                path: '/text-pages/:id/update',
                component: TextPageUpdate,
            },
            {
                path: '/config',
                component: Config,
            },
        ]
    },

]

export const router = new VueRouter({
    routes
})